module.exports = __webpack_public_path__ + "img/icon-uni.e9e91797.svg";